__turbopack_context__.v({
  "bannerGlow": "dailyDiary-module-scss-module__KOnlva__bannerGlow",
  "diary-breathe": "dailyDiary-module-scss-module__KOnlva__diary-breathe",
  "diary-glow": "dailyDiary-module-scss-module__KOnlva__diary-glow",
  "scene": "dailyDiary-module-scss-module__KOnlva__scene",
  "todayRing": "dailyDiary-module-scss-module__KOnlva__todayRing",
});
